import { ListAltOutlined } from '@mui/icons-material';
import { WidgetHeader, WidgetIcon } from '@procureai/ui-mui';

interface SourcingProjectRequestListWidgetHeaderProps {
  title: string;
}

export const SourcingProjectRequestListWidgetHeader = ({ title }: SourcingProjectRequestListWidgetHeaderProps) => {
  return <WidgetHeader title={title} icon={<WidgetIcon icon={<ListAltOutlined fontSize="small" />} />} />;
};
